module.exports = __webpack_public_path__ + "img/bluesky3100_22.8f9d1134.jpg";